import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApp } from '../context/AppContext';
import usersData from '../data/users.json';
import Sidebar from './Sidebar/Sidebar';
import TopBar from './TopBar/TopBar';
import PageContainer from './PageContainer/PageContainer';

const MainLayout = ({ children }) => {
    const location = useLocation();
    const { authUser } = useAuth();
    const { setCurrentRole, setCurrentUser } = useApp();

    // Sync auth user with AppContext for backward compatibility
    useEffect(() => {
        if (authUser) {
            setCurrentRole(authUser.user_type);

            // Find matching user in usersData to get full user info (phone, city, etc.)
            // Match by role and name, or by email if we add email to usersData
            const fullUser = usersData.find(u =>
                u.role === authUser.user_type &&
                (u.name === authUser.name || u.id === authUser.id)
            );

            // Merge auth user with full user data
            const mergedUser = fullUser
                ? { ...fullUser, ...authUser } // Full user data takes precedence, but keep auth fields
                : {
                    id: authUser.id,
                    name: authUser.name,
                    role: authUser.user_type,
                    email: authUser.email,
                };

            setCurrentUser(mergedUser);
        } else {
            setCurrentRole(null);
            setCurrentUser(null);
        }
    }, [authUser, setCurrentRole, setCurrentUser]);

    const getPageTitle = () => {
        const path = location.pathname;
        const titles = {
            '/admin/dashboard': 'Dashboard',
            '/admin/orders': 'Orders Management',
            '/admin/users': 'Users Management',
            '/admin/pumps': 'Petrol Pumps',
            '/admin/managers': 'Managers',
            '/admin/agents': 'Agents',
            '/admin/settlements': 'Settlements',
            '/admin/settings': 'Settings',
            '/manager/dashboard': 'Dashboard',
            '/manager/orders': 'Orders',
            '/manager/earnings': 'Earnings',
            '/manager/profile': 'Profile',
            '/agent/dashboard': 'Dashboard',
            '/agent/referrals': 'Referrals',
            '/agent/points': 'Points & Redemption',
            '/agent/profile': 'Profile',
        };
        return titles[path] || 'Dashboard';
    };

    return (
        <div className="main-layout">
            <Sidebar />
            <TopBar pageTitle={getPageTitle()} />
            <PageContainer>{children}</PageContainer>
        </div>
    );
};

export default MainLayout;

